import styled from 'styled-components';

import {deepLinkBlockWrapperStyles} from '../deepLinkBlock';

export const WeavePanelWrapper = styled.div`
  white-space: normal;
  margin-bottom: 24px;
  ${deepLinkBlockWrapperStyles}

  // HACK(WB-4910): Avoid page breaks during PDF export. Must use
  // 'report-width-print-*' selectors so this element can be detected by re-
  // positioning logic run during export.
  .report-width-print-portrait &,
  .report-width-print-landscape & {
    break-inside: avoid;
    page-break-inside: avoid;
  }
`;
